import AppRouter from "./AppRouter";
import NavBar from "./components/Navigation/NavBar";
import Footer from "./components/Footer";
import ContactModal from "./components/Contact/ContactModal";
import React, {useEffect, useState} from "react";
import Toast from "./components/Toast";
import Drawer from "./components/Navigation/Drawer";
import CarouselDetailModal from "./components/Carousel/CarouselDetailModal";
import {fetchAPI} from "./helpers/APIHelper";

export const ROOT_DIR = window.location.origin;

const APP_CONTEXT_DEFAULTS = {
    contactModalIsOpen: false,
    contactModalPropertyRef: null,
    toastIsOpen: false,
    toastMessage: "",
    toastType: "check",
    drawerIsOpen: false,
    carouselDetailModalIsOpen: false,
    carouselDetailModalAttachments: [],
    carouselDetailModalId: 0,
    cities: [],
    types: []
}

export const AppContext = React.createContext({
    contactModalIsOpen: APP_CONTEXT_DEFAULTS.contactModalIsOpen,
    setContactModalIsOpen: (contactModalIsOpen) => {
        this.contactModalIsOpen = contactModalIsOpen;
    },
    contactModalPropertyRef: APP_CONTEXT_DEFAULTS.contactModalPropertyRef,
    setContactModalPropertyRef: (contactModalPropertyRef) => {
        this.contactModalPropertyRef = contactModalPropertyRef;
    },
    toastIsOpen: APP_CONTEXT_DEFAULTS.toastIsOpen,
    setToastIsOpen: (toastIsOpen) => {
        this.toastIsOpen = toastIsOpen;
    },
    toastMessage: APP_CONTEXT_DEFAULTS.toastMessage,
    setToastMessage: (toastMessage) => {
        this.toastMessage = toastMessage;
    },
    toastType: APP_CONTEXT_DEFAULTS.toastType,
    setToastType: (toastType) => {
        this.toastType = toastType;
    },
    drawerIsOpen: APP_CONTEXT_DEFAULTS.drawerIsOpen,
    setDrawerIsOpen: (drawerIsOpen) => {
        this.drawerIsOpen = drawerIsOpen;
    },
    carouselDetailModalIsOpen: APP_CONTEXT_DEFAULTS.carouselDetailModalIsOpen,
    setCarouselDetailModalIsOpen: (carouselDetailModalIsOpen) => {
        this.carouselDetailModalIsOpen = carouselDetailModalIsOpen;
    },
    carouselDetailModalAttachments: APP_CONTEXT_DEFAULTS.carouselDetailModalAttachments,
    setCarouselDetailModalAttachments: (carouselDetailModalAttachments) => {
        this.carouselDetailModalAttachments = carouselDetailModalAttachments;
    },
    carouselDetailModalId: APP_CONTEXT_DEFAULTS.carouselDetailModalId,
    setCarouselDetailModalId: (carouselDetailModalId) => {
        this.carouselDetailModalId = carouselDetailModalId;
    },
});

function App() {
    const MOBILE_MAX_WIDTH = 760;

    const [contactModalIsOpen, setContactModalIsOpen] = useState(APP_CONTEXT_DEFAULTS.contactModalIsOpen);
    const [contactModalPropertyRef, setContactModalPropertyRef] = useState(APP_CONTEXT_DEFAULTS.contactModalPropertyRef);
    const [carouselDetailModalIsOpen, setCarouselDetailModalIsOpen] = useState(APP_CONTEXT_DEFAULTS.carouselDetailModalIsOpen);
    const [carouselDetailModalAttachments, setCarouselDetailModalAttachments] = useState(APP_CONTEXT_DEFAULTS.carouselDetailModalAttachments);
    const [carouselDetailModalId, setCarouselDetailModalId] = useState(APP_CONTEXT_DEFAULTS.carouselDetailModalId);

    const [toastIsOpen, setToastIsOpen] = useState(APP_CONTEXT_DEFAULTS.toastIsOpen);
    const [toastMessage, setToastMessage] = useState(APP_CONTEXT_DEFAULTS.toastMessage);
    const [toastType, setToastType] = useState(APP_CONTEXT_DEFAULTS.toastType);

    const [drawerIsOpen, setDrawerIsOpen] = useState(APP_CONTEXT_DEFAULTS.drawerIsOpen);

    const [citiesLoading, setCitiesLoading] = useState(localStorage.getItem('cities') === null);
    const [typesLoading, setTypesLoading] = useState(localStorage.getItem('types') === null);
    const [promotionsLoading, setPromotionsLoading] = useState(localStorage.getItem('promotions') === null);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_MAX_WIDTH);

    function handleWindowSizeChange() {
        setIsMobile(window.innerWidth <= MOBILE_MAX_WIDTH);
    }

    useEffect(() => {
        if (localStorage.getItem('cities') === null || JSON.parse(localStorage.getItem('cities')).timestamp <= new Date().setHours(new Date().getHours() - 1)) {
            fetchAPI({endpoint: '/data/cities'})
                .then(res => {
                    localStorage.setItem('cities', JSON.stringify({data: res.data, timestamp: new Date().getTime()}));
                    setCitiesLoading(false);
                });
        }

        if (localStorage.getItem('types') === null || JSON.parse(localStorage.getItem('types')).timestamp <= new Date().setHours(new Date().getHours() - 1)) {
            fetchAPI({endpoint: '/data/types'})
                .then(res => {
                    localStorage.setItem('types', JSON.stringify({data: res.data, timestamp: new Date().getTime()}));
                    setTypesLoading(false);
                });
        }

        if (localStorage.getItem('promotions') === null || JSON.parse(localStorage.getItem('promotions')).timestamp <= new Date().setHours(new Date().getHours() - 1)) {
            fetchAPI({endpoint: '/promotions'})
                .then(res => {
                    localStorage.setItem('promotions', JSON.stringify({data: res.data, timestamp: new Date().getTime()}));
                    setPromotionsLoading(false);
                });
        }

        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, [])

    const value = {
        contactModalIsOpen,
        setContactModalIsOpen,
        contactModalPropertyRef,
        setContactModalPropertyRef,
        toastIsOpen,
        setToastIsOpen,
        toastMessage,
        setToastMessage,
        toastType,
        setToastType,
        drawerIsOpen,
        setDrawerIsOpen,
        carouselDetailModalIsOpen,
        setCarouselDetailModalIsOpen,
        carouselDetailModalAttachments,
        setCarouselDetailModalAttachments,
        carouselDetailModalId,
        setCarouselDetailModalId,
        citiesLoading,
        typesLoading,
        promotionsLoading,
        isMobile
    };

    function handleClick() {
        if (drawerIsOpen) {
            setDrawerIsOpen(false);
        }

        if (contactModalIsOpen) {
            setContactModalIsOpen(false);
        }

        if (carouselDetailModalIsOpen) {
            setCarouselDetailModalIsOpen(false);
        }
    }

    if (window.location.href.includes("vitrine")) {
        return <AppRouter/>
    }

    return (
        <AppContext.Provider value={value}>
            <ContactModal/>
            <CarouselDetailModal/>
            <Drawer/>
            <Toast/>
            <header
                onClick={drawerIsOpen || contactModalIsOpen || carouselDetailModalIsOpen ? handleClick : null}
                className={drawerIsOpen || contactModalIsOpen || carouselDetailModalIsOpen ? "blur-md *:pointer-events-none" : ""}>
                <NavBar/>
            </header>
            <main onClick={drawerIsOpen || contactModalIsOpen || carouselDetailModalIsOpen ? handleClick : null}
                  className={drawerIsOpen || contactModalIsOpen || carouselDetailModalIsOpen ? "blur-md *:pointer-events-none" : ""}>
                <AppRouter/>
            </main>
            <footer onClick={drawerIsOpen || contactModalIsOpen || carouselDetailModalIsOpen ? handleClick : null}
                    className={drawerIsOpen || contactModalIsOpen || carouselDetailModalIsOpen ? "blur-md *:pointer-events-none" : ""}>
                <Footer/>
            </footer>
        </AppContext.Provider>
    );
}

export default App;
